import { Injectable } from '@angular/core';
import { EntityStore, StoreConfig } from '@datorama/akita';
import { SecurityProfileModel } from './security-profile.model';

function createInitialState(): SecurityProfileModel {
  return <SecurityProfileModel>{};
}

@Injectable({ providedIn: 'root' })
@StoreConfig({ name: 'security-profile', idKey: 'userOrgProfileId' /* userOrgProfileId, not securityProfileId is the key!*/ })
export class SecurityProfileStore extends EntityStore<SecurityProfileModel> {
  constructor() {
    super(createInitialState());
  }
}
